export default "__VITE_ASSET__Bb7Kj_HT__"